import actions from './store/actions';
import moment from 'moment';
import { Map } from 'immutable';
import { find, pick, toLower,reject, isNil } from 'ramda';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import { setHeaderLang, momentLangCodes } from '@synergycms_core/utils/api';
import { apiGetter } from '@synergycms_core/utils/api';

const {
    hotels: hotelsActions,
    app: appActions,
    customer : customerActions,
    system: systemActions,
} = actions;

const {
  webType: webTypeActions,
  params: paramsActions,
  currencies: currenciesActions,
  currentCurrency : currentCurrencyActions,
  currentHotel: currentHotelActions
} = customerActions;


const setLang = (windowConfig) => {
  //Se tiene definido el lang (ya sea directamente o mediante gtm)
  let lang = windowConfig?.lang_info?.code || windowConfig.lang || windowConfig.config?.lang;

  //No se tiene definido el lang, autodetectar html lang o navegador
  if(!lang) {
    const userLang = document.documentElement.lang || navigator.language || navigator.userLanguage;
    lang = userLang.split('-')[0];
  }

  apiGetter().setHeader(lang);
  toLower(momentLangCodes(lang || "es"));
  moment.locale(lang);

}


const configFileds = [
  'element_id',
  'url',
  'avail_url',
  'max_rooms',
  'max_adults',
  'default_adults',
  'max_childs',
  'default_childs',
  'outer_web',
  'enable_wi_url',
  'show_modal_view',
  'focus_on_modal_view',
  'drop_down_list_type',
  'engine_visible',
  'enable_promotion_code',
  'theme',
  'hotels_catalog',
  'theme_values',
  'ignore_synergy_config',
  'hotel_id',
  'hotel_code',
  'links'];

  var engineFields = [
    "config",
    "i18n"
  ];

  var baseFields = [
    "lang_info",
    "lang",
    "hotels_info",
    "currencies",
    "group",
    "web_type",
    "hotel_id",
    "hotel_code",
    "country_id",
    "province_id",
    "city_id",
    "currency_code",
    "occups_free",
    "outer_web"
  ];



export const toFrontendConfig = () => {
  const config = pick(configFileds, window.engine_sygy_data);

  config.max_rooms = window.engine_sygy_data?.limits?.rooms?.max;

  config.max_adults = window.engine_sygy_data?.limits?.adults?.max;
  config.default_adults = window.engine_sygy_data?.limits?.adults?.default;

  config.max_childs = window.engine_sygy_data?.limits?.childs?.max;
  config.default_childs = window.engine_sygy_data?.limits?.childs?.default;

  return reject(isNil, {
    hotel_id : window.id_hotel,
    hotel_code : window.hotel_code,
    country_id : window.country_id,
    province_id : window.province_id,
    city_id : window.city_id,
    ...pick(baseFields, window.engine_sygy_data),
    "cms-engine": reject(isNil, {
      i18n: window.i18n,
      ...pick(engineFields, window.engine_sygy_data),
      config: {
        avail_url : config.url,
        ...reject(isNil, config)
      }
    })
  })
};

export const parseFrontLoader = (baseConfig) => {
  if(!baseConfig){
    return null;
  }
  const engine = baseConfig?.["cms-engine"] || {};
  const config = baseConfig?.["cms-engine"]?.config || {};
  config.max_rooms = config?.max_rooms || config?.limits?.rooms?.max;

  config.max_adults = config?.max_adults || config?.limits?.adults?.max;
  config.default_adults = config?.default_adults || config?.limits?.adults?.default;

  config.max_childs = config?.max_childs || config?.limits?.childs?.max;
  config.default_childs = config?.default_childs || config?.limits?.childs?.default;


  return reject(isNil, {
    ...baseConfig,
    "cms-engine": reject(isNil, {
      ...engine,
      config: {
        ...reject(isNil,{
          avail_url : config.url,
          hotel_id : baseConfig.hotel_id,
          hotel_code : baseConfig.hotel_code,
          country_id : engine.country_id,
          province_id : engine.province_id,
          city_id :engine.city_id
        }),
        ...reject(isNil, config)
      },
    })
  })
}


const initializeStore = (dispatch, getState) => {
  //dispatch(langActions.get(window.lang_info));

  dispatch(systemActions.get());
  dispatch(appActions.name.get("searchEngine"));

  let  windowConfig = window.frontLoader;

  if(!windowConfig && window.engine_sygy_data) {
     windowConfig  = toFrontendConfig()
  }

  windowConfig = parseFrontLoader(windowConfig);

  let { hotel_id : hotId, hotel_code : hotelCode, group, hotels_info, currencies, currency_code} = windowConfig;

  const webtype = windowConfig.web_type = windowConfig.web_type || ((hotId || hotelCode) && "WI") || (windowConfig.group && "PORTAL") || "WI";

  setLang(windowConfig);
  dispatch(webTypeActions.get(webtype));


  if (group === "eurostarshotelsficha") {
    group = "eurostarshotels";
  }


  let baseDataRequest = Promise.resolve();
  if (webtype === "WI") {
    baseDataRequest = Promise.resolve(hotId);
    if(!hotId) {
      baseDataRequest = dispatch(hotelsActions.info.getAsync(hotelCode)).then(listId => {
        hotId = listId[hotelCode];
        return hotId;
      }).catch((err)=> {
        console.log(err);
      });
    }
  }

  baseDataRequest.then((hotId) => {
    hotId && dispatch(currentHotelActions.set(hotId));
    return dispatch(actions.app.config.getEngineAsync(windowConfig, hotId)).then(response => {


      return response;
    });
  }).then(() => {
    dispatch(appActions.loaded.get(true));
    const engineConfigs = contextualizeAppConfig(getState(), hotId, "engine_config");
    if (engineConfigs.get("prices_active")) {
      const destination = !hotId && getDefaultDestination(hotels_info, windowConfig);
      const requiredAction = dispatch(currencies && currencies.length ?  currenciesActions.get(currencies) : currenciesActions.getAsync());
      if(destination) {
        destination && dispatch(paramsActions.availCacheParams(Map({
          city_id: destination.isCity && destination.id,
          country_id: destination.isCountry && destination.id,
          province_id: destination.isProvince && destination.id,
          start: moment().format('YYYY-MM-DD')
        })));
      } else if(hotId) {
        dispatch(paramsActions.availCacheParams(Map({
          hotelId: hotId,
          start: moment().format('YYYY-MM-DD')
        })));
      }


      return Promise.resolve(requiredAction).then(() => {
        dispatch(currentCurrencyActions.set(engineConfigs.get( "currency_code" ) || currency_code, destination));
        if(getState().getIn(["customer", "current_currency"])) {
            return dispatch(actions.availCache.getAsync());
        }
      });
    }
  }).catch((err)=> {
      console.log(err);
  });
};

var getDefaultDestination = (hotelsInfo = {}, params = {}) => {
  const getId = (snake, camel) => params[snake] != null ? params[snake] : params[camel];
  const findById = (collection = [], id) => {
    if (id == null) return null;
    const idStr = String(id);
    return find(item => String(item.id) === idStr, collection) || null;
  };

  const city = findById(hotelsInfo.cities, getId('city_id', 'cityId'));
  if (city) return { ...city, city_id: city.id, isCity: true };

  const province = findById(hotelsInfo.provinces, getId('province_id', 'provinceId'));
  if (province) return { ...province, province_id: province.id, isProvince: true };

  const country = findById(hotelsInfo.countries, getId('country_id', 'countryId'));
  if (country) return { ...country, country_id: country.id, isCountry: true };

  return null;
};

export default initializeStore;